<template>
  <div>
    <PageTitle title="SMS" />
    <v-container fluid class="lighten-12 content">
      <v-card class>
        <v-tabs v-model="tab" background-color="primary" dark hide-slider>
          <v-tabs-slider></v-tabs-slider>
          <v-tab v-for="item in items" :key="item.tab">
            {{ item.tab }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-row>
              <v-col>
                <TemplateTabs />
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-row>
              <v-col>
                <BulkSMS />
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-row>
              <v-col>
                <SingleSMS />
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-row>
              <v-col>
                <SMSService />
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-row>
              <v-col>
                <Review />
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
      <div>
        <v-progress-linear
          v-if="LoadingBar"
          color="cyan"
          indeterminate
        ></v-progress-linear>
      </div>
      <v-btn
        ref="showBtn"
        @click="goto('document-section')"
        v-show="false"
      ></v-btn>
    </v-container>
  </div>
</template>

<script>
import { mapState } from 'vuex';

// Components
import TemplateTabs from './TemplatesTab.vue';
import BulkSMS from './BulkSMS.vue';
import SingleSMS from './SingleSMS.vue';
import PageTitle from '../../components/shared/PageTitle.vue';
import SMSService from './SMSService.vue';
import Review from './Review.vue';

export default {
  data: () => ({
    toggle_exclusive: undefined,
    isChecked: false,

    items: [
      { tab: 'Templates', content: '' },
      { tab: 'Bulk SMS', content: '' },
      { tab: 'Single SMS', content: '' },
      { tab: 'SMS Service', content: '' },
      { tab: 'Reviews', content: '' },
    ],
    tab: '',
    tab1: '',
    tab2: '',
  }),

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    TemplateTabs,
    BulkSMS,
    SingleSMS,
    PageTitle,
    SMSService,
    Review,
  },
};
</script>
